import { useState } from 'react';

export default function useToggle() {
  const [isOpen, setOpen] = useState(false);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  return { isOpen, toggle: handleClick };
}
